module.exports = __webpack_public_path__ + "img/google-play-en.db9b21a.png";